import { Injectable } from "@angular/core";
import {
    DefaultHttpClient,
    HttpRequest,
    HttpResponse,
    HttpTransportType,
    HubConnection,
    HubConnectionBuilder,
    HubConnectionState,
    LogLevel,
} from "@microsoft/signalr";
import { AuthenticationService } from "../login/authentication/authentication.service";
import { BehaviorSubject, Observable } from "rxjs";
import { MiembrosModel } from "src/app/shared/models/chat/miembros.model";
import { HttpClient } from "@angular/common/http";
import { GetMensajesModel } from "src/app/shared/models/chat/getMensajes.model";
import { PostLeidoModel } from "src/app/shared/models/chat/PostLeido.model";
import { GruposModel } from "src/app/shared/models/chat/grupos.model";
import { LoginUserResponse } from 'src/app/shared/models/login/loginchat.model';


class CustomHttpClient extends DefaultHttpClient {
    dns: string;

    constructor(private auth: AuthenticationService) {
        super(console);

        this.dns = this.auth.currentDns;
    }
    public send(request: HttpRequest): Promise<HttpResponse> {
        request.headers = { ...request.headers, dns: this.auth.currentDns };
        return super.send(request);
    }
}

@Injectable({
    providedIn: "root",
})
export class ChatService {
    connection: HubConnection;
    newMessage: BehaviorSubject<GetMensajesModel> =
        new BehaviorSubject<GetMensajesModel>(null);

    get urlComms(): string {
        return `${this.auth.urlComms}`;
    }
    get chatConnected(): boolean {
        return this.connection?.state == HubConnectionState.Connected;
    }

    constructor(
        private auth: AuthenticationService,
        private http: HttpClient
    ) { }

    loginChat(): Observable<any> {

        let url = `${this.urlComms}Login`;
        const dni = this.auth.currentUserValue.dni;
        const login = this.auth.currentUserValue.login;
        const pass = this.auth.currentUserValue.password;

        return this.http.post<any>(
            url,
            {
                login: login,
                password: pass,
                dni: dni,
            },
            {
                responseType: "text" as "json",
            }
        );

    }

    addNewConductor(data: MiembrosModel): Observable<MiembrosModel> {
        var url = this.urlComms + "Usuarios/AddNewConductor";
        return this.http.post<MiembrosModel>(url, data);
    }

    getCredencialesDni(dni: string): Observable<LoginUserResponse> {
        var url = `${this.auth.urlTrafico}login/getloggeduser?dni=${dni}`;
        return this.http.get<LoginUserResponse>(url);
    }

    sendMessage(msg: string): Observable<any> {
        var data = {
            mensaje: msg,
            remitenteId: this.auth.currentUserValue._id,
            fecha: new Date(),
            esParaTrafico: true,
        };
        var url = this.urlComms + "Mensajeria/SendMensaje";
        return this.http.post<any>(url, data);
    }

    getMensajes(skip: number, take: number): Observable<GetMensajesModel[]> {
        console.log("getMensajes");

        var filter = {
            skip: skip,
            take: take,
            userId: this.auth.currentUserValue._id,
        };
        var url = this.urlComms + "Mensajeria/GetMensajesByIdChronological";
        return this.http.post<GetMensajesModel[]>(url, filter);
    }

    postLeido(data: PostLeidoModel[]): Observable<void> {
        var url = this.urlComms + "Grupos/PostLeido";
        return this.http.post<void>(url, data);
    }

    //#region SignalR

    initChat() {
        this.buildConnection();
        this.startChat();
        this.onReceived();
        this.onReceivedGroup();
    }

    buildConnection() {
        this.connection = new HubConnectionBuilder()
            .withUrl(this.auth.urlSgComms + "chat?dni=" + this.auth.currentUserValue.dni, {
                skipNegotiation: true,
                transport: HttpTransportType.WebSockets,
                accessTokenFactory: () =>
                    this.auth.currentUserValue.tokenTrafico,
                httpClient: new CustomHttpClient(this.auth),
            })
            .withAutomaticReconnect({
                nextRetryDelayInMilliseconds: this.reconnect,
            })
            .configureLogging(LogLevel.Information)
            .build();
    }
    private reconnect(retryContext) {
        return 10000;
    }
    startChat() {
        this.connection.start().then((res) => {
            console.log("Connected");
        });
    }

    stopChat() {
        if (this.connection && this.chatConnected) {
            this.connection.stop().then((res) => {
                console.log("Stopped");
            });
        }
    }

    onReceived() {
        this.connection.on("receiveMessage", (data: GetMensajesModel) => {
            this.newMessage.next(data);
        });
    }

    onReceivedGroup() {
        this.connection.on("updateGrupo", (data: GruposModel) => {
            console.log("updateGrupo");
        });
    }

    private decodeCred(): string[] {
        return atob(this.auth.currentUserValue.basicauth).split(":");
    }

    //#endregion
}
